import { sortBy } from 'lodash';
import { SortOptions } from 'src/components/subHeader/SubHeaderWithSorting.interface';
import {
  useGetAllProducts,
  useGetProductCategories,
  useGetProductVariationTypes,
  useParamQuery,
} from 'src/hooks';
import { IProduct } from 'src/interfaces';

import { filteredProducts } from '../modules/AddProductCategoryPage.helper';

export const useAddProductCategoryPage = () => {
  const { data: productCardData = [], isLoading: productCardLoading } =
    useGetAllProducts([], [], undefined, []);
  const { onChangeParams, activeFilters } = useParamQuery();

  const { data: productCategories = [] } = useGetProductCategories([
    'sort=*name',
  ]);
  const { data: productVariationTypes = [] } = useGetProductVariationTypes([
    'sort=*name',
  ]);

  const sortProductsByModified = (products: IProduct[]) => {
    return sortBy(products, 'product_name');
  };

  const filteredProductCardData = filteredProducts(
    sortProductsByModified(productCardData),
    activeFilters,
    SortOptions.ALPHABETICALLY,
    'asc',
  );

  return {
    productCardData: filteredProductCardData,
    productCardLoading,
    onChangeParams,
    productCategories,
    productVariationTypes,
  };
};
